import { isCommentNode } from 'anodum';
import isTextNodeWithSpacingOnly from '../verifiers/is-text-node-with-spacing-only';
import isEmptyTextNode from '../verifiers/is-empty-text-node';

const findPrevNode = (node, breakNode = null) => {
  let currentNode = node;

  while (currentNode) {
    if (currentNode === breakNode) {
      return null;
    }

    if (currentNode.previousSibling) {
      currentNode = currentNode.previousSibling;

      if (
        !isEmptyTextNode(currentNode) &&
        !isTextNodeWithSpacingOnly(currentNode) &&
        !isCommentNode(currentNode)
      ) {
        break;
      }
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return currentNode;
};

export default findPrevNode;
